


import TimelineList from "@/views/cards/TimelineList.vue";
import TimelineItem from "@/views/cards/TimelineItem.vue";

export default {
  name: "rotas-timeline",
  components: {
    TimelineList,
    TimelineItem
  },
    props: {
      rotas: {
        type: Array,
        default: () => {
          [];
        },
      }
    },
    methods: {
    closeAll() {
      //this.rotas.forEach((item) => (item.open = false));
    },
    getIconeByStatus(status:Number) {
        if (status === 0) return 'ni ni-box-2'; // Pedido desativado
        if (status === 1) return 'ni ni-box-2';     // Pedido ativo
        if (status === 2) return 'ni ni-check-bold'; // Pedido concluído
        if (status === 5) return 'fas fa-clock'; 
        return ' ni ni-box-2';
      },
     
    getColorByStatus(status:Number) {
        if (status === 0) return 'info'; // Pedido desativado
        if (status === 1) return 'warning';     // Pedido ativo
        if (status === 2) return 'success'; // Pedido concluído
        if (status === 5) return 'danger';
        return '';
      },
    getClassByStatus(status:Number) {
        if (status === 0) return 'pedido-status-desativado'; // Pedido desativado
        if (status === 1) return 'pedido-status-ativo';     // Pedido ativo
        if (status === 2) return 'pedido-status-concluido'; // Pedido concluído
        if (status === 5) return 'pedido-status-aguardando'; // Pedido concluído
        return '';
      }
    },
    data() {
      return {
        por_pagina : false,
        isLast: false,
      }
    },
    setup(props:any) {
      // Acessando as props diretamente sem usar `this`
      const setCenter = (rota: any) => {
        if (rota.Operacao && rota.Operacao.latitude && rota.Operacao.longitude) {
          const newLocation = {
            lat: parseFloat(rota.Operacao.latitude),
            lng: parseFloat(rota.Operacao.longitude),
          };

          if (props.map && typeof props.map.setCenter === 'function') {
            props.map.setCenter(newLocation); // Define o novo cen tro do mapa
          } else {
            console.error("Mapa inválido ou setCenter não é uma função");
          }
        } else {
          console.error("Coordenadas inválidas ou não fornecidas");
        }
      };

      const setCenterItem = (pedido: any) => {
        if (pedido.latitude && pedido.longitude) {
          const newLocation = {
            lat: parseFloat(pedido.latitude),
            lng: parseFloat(pedido.longitude),
          };

          if (props.map && typeof props.map.setCenter === 'function') {
            props.map.setCenter(newLocation); // Define o novo cen tro do mapa
          } else {
            console.error("Mapa inválido ou setCenter não é uma função");
          }
        } else {
          console.error("Coordenadas inválidas ou não fornecidas");
        }
      };

      // Retorna os métodos ou variáveis que você quer expor
      return {
        setCenter,
        setCenterItem
      };
    }
};
